import { createContext, useContext, useState, useRef, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const location = useLocation();
  const pathname = location.pathname;
  const isGeneratorPage = pathname === "/generator";

  const [isConfigOpen, setIsConfigOpen] = useState(true);
  const onSaveHandlerRef = useRef(null);
  const onUpdateParamsHandlerRef = useRef(null);
  const guiContainerRef = useRef(null);

  // Auto-open on generator page
  useEffect(() => {
    if (isGeneratorPage) {
      setIsConfigOpen(true);
    } else {
      setIsConfigOpen(false);
    }
  }, [isGeneratorPage]);

  const registerSaveHandler = useCallback((handler) => {
    onSaveHandlerRef.current = handler;
  }, []);

  const callSaveHandler = useCallback(() => {
    if (onSaveHandlerRef.current) {
      onSaveHandlerRef.current();
    }
  }, []);

  const registerUpdateParamsHandler = useCallback((handler) => {
    onUpdateParamsHandlerRef.current = handler;
  }, []);

  const triggerUpdateParams = useCallback((newParams) => {
    if (onUpdateParamsHandlerRef.current) {
      onUpdateParamsHandlerRef.current(newParams);
    }
  }, []);

  return (
    <ConfigContext.Provider
      value={{
        isConfigOpen,
        setIsConfigOpen,
        guiContainerRef,
        callSaveHandler,
        registerSaveHandler,
        isGeneratorPage,
        registerUpdateParamsHandler,
        triggerUpdateParams,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within ConfigProvider");
  }
  return context;
}
